import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants";
import {
  UpdateMerchantPriceBody,
  UpdateMerchantPriceResponse
} from "./updateMerchantPrice.types";

export const requestUpdateMerchantPrice = async (
  body: UpdateMerchantPriceBody
): Promise<UpdateMerchantPriceResponse> => {
  return await instance.post(ApiRoutesProducts.MerchantPrice, body);
};
